import styled from 'styled-components'

export const DropDownContainer = styled.div`
  position: relative;
  display: block;
  width: 100%;
  z-index: 999;
`

export const DropDown = styled.div`
  background: #fff;
  display: block;
  min-width: 100px;
  width: 100%;
  position: absolute;
  top: 100%;
  left: 0;
  top: 0;
  max-height: 220px;
  overflow-y: auto;
  padding: 24px;
  box-shadow: rgba(35, 44, 53, 0.1) 0px 0 40px 0px;
`

export const DropDownElement = styled.div`
  cursor: pointer;
  font-family: Ubuntu, sans-serif;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  letter-spacing: 0.4px;
  font-size: 14px;
  font-weight: 300;
  transition: color 0.1s ease-in-out 0s;
  width: auto;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 36px;
  cursor: pointer;
  transition: color 0.3s ease-in-out;
  text-align: center;
  color: ${(props: any) => (props.isCurrentPrice ? '#0093b2' : '#646464')};

  &:hover {
    color: #0093b2;
  }
`
